import {
  DecisionActionRequest, DecisionPage, DecisionSummary,
  HomeCalendarGranularity, HomeCalendarViewMode, NextBestDecision
} from "../../models/home";
import { CalendarAdapter } from "./adapters/calendar.adapter";
import { HomeDecisionActionCoordinator } from "./home-decision-action.coordinator";
import { HomeDashboardStore } from "./home.component.dashboard-store";
import { HomeDashboardRefreshController } from "./home-dashboard-refresh.controller";
import { DecisionStateFilter, LoadState, projectDecisionStateParam } from "./home.component.state";

export class HomeDashboardInteractionController {
  constructor(
    private readonly store: HomeDashboardStore,
    private readonly refresh: HomeDashboardRefreshController,
    private readonly actions: HomeDecisionActionCoordinator
  ) {}

  changeStateFilter(state: DecisionStateFilter): void {
    const current = this.store.activeStateFilterSubject.value;
    this.store.activeStateFilterSubject.next(current === state ? "all" : state);
  }
  selectDecision(decisionId: string): void {
    this.actions.clearFeedback();
    this.store.selectedDecisionIdSubject.next(decisionId);
    this.refresh.refreshDecisionDetail();
  }
  closeDecisionDetail(): void {
    this.actions.clearFeedback();
    this.store.selectedDecisionIdSubject.next(null);
  }
  changeActivityHistoryPage(page: number): void {
    this.store.activityHistoryPageSubject.next(page);
    this.store.activityHistoryRefresh$.next();
  }
  changeViewMode(mode: HomeCalendarViewMode): void { this.store.viewModeSubject.next(mode); }
  changeCalendarGranularity(value: HomeCalendarGranularity): void { this.store.calendarGranularitySubject.next(value); }
  shiftCalendarPeriod(direction: number): void {
    this.store.calendarAnchorDateSubject.next(CalendarAdapter.shiftAnchorDate(
      this.store.calendarAnchorDateSubject.value,
      this.store.calendarGranularitySubject.value,
      direction
    ));
  }
  jumpToToday(): void { this.store.calendarAnchorDateSubject.next(CalendarAdapter.toDateKey(new Date())); }
  changeCalendarAnchorDate(value: string): void { this.store.calendarAnchorDateSubject.next(value); }
  executeDecisionAction(event: { decisionId: string; actionKey: string; request?: DecisionActionRequest }): void {
    this.actions.execute(event);
  }
  getDecisionSummary(
    state: LoadState<DecisionPage> | null | undefined,
    next: LoadState<NextBestDecision | null> | null | undefined
  ): DecisionSummary | null {
    return state?.data?.summary ?? next?.data?.summary ?? null;
  }
  toDecisionFilters(state: DecisionStateFilter): { state?: string } | undefined {
    const stateParam = projectDecisionStateParam(state);
    return stateParam ? { state: stateParam } : undefined;
  }
}
